import { render, staticRenderFns } from "./Public1099NEC.vue?vue&type=template&id=3fcf4de4&scoped=true&"
import script from "./Public1099NEC.vue?vue&type=script&lang=ts&"
export * from "./Public1099NEC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcf4de4",
  null
  
)

export default component.exports